import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import ApiLocationForm from './forms/ApiLocationForm';
import ApiLocationList from './lists/ApiLocationList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import connect from "../../reducers/connect";

class ApiLocationEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editorHeader: this.props.values.name || "Új helyiség felvitele"
        }
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.setState({editorHeader: data.name});
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.setState({editorHeader: "Új helyiség felvitele"});
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const apiLocationForm = apiLocationForm;
        const apiLocationList = apiLocationList;
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const props = {...this.props};
        if (!Array.isArray(props.listFilter)) {
            if (props.listFilter) {
                props.listFilter = [props.listFilter];
            } else {
                props.listFilter = [];
            }
        }
        props.listFilter.push({field: "client", value: this.props.context.client.partner_id});
        return <Fragment>
                <List
                    {...props}
                    collapsed={props.collapsed || false}
                    theme="default"
                    header={"Szállítási címek"}
                    footer={[
                        <Button
                            key="0"
                            disabled={props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <ApiLocationList
                        ref={(el) => this.list = el}
                        {...props}
                        loadForm={this.loadForm}
                    />
                </List>
                <Editor
                    {...props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={this.state.editorHeader}
                    footer={[
                        <Button
                            key="0"
                            disabled={!props.dirty || props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>
                    ]}
                >
                    <ApiLocationForm {...props} />
                </Editor>
        </Fragment>;
    }
}

export default connect((state) => {
    return {
        context: state.app.context,
    }
})(createEditor({componentName: "apilocation", WrappedComponent: ApiLocationEditor}));
